import React from 'react';
import './casual.scss';
import casualcutted from '../../../assets/casual-cutted.png';
const CasualImageSvg: React.FC = () => {
  return (
    <svg
      width="178.03877mm"
      height="187.33157mm"
      viewBox="0 0 178.03877 187.33157"
      version="1.1"
         id="profileimage"
    >
      <defs id="defs1">
        <clipPath clipPathUnits="userSpaceOnUse" id="clipPath4-4">
          <path
            id="path4-5"
            d="m 104.72585,75.63911 c -26.541319,0.94497 -29.07794,16.426466 -57.677618,54.95271 -35.199613,47.41693 -27.336443,54.8437 11.587919,93.37363 38.924371,38.52993 67.057659,46.97368 119.465569,15.82642 52.4079,-31.14725 35.79021,-33.58825 39.25083,-88.35791 3.46062,-54.769659 -40.21787,-67.694605 -89.80175,-74.23112 -9.29698,-1.225598 -16.70004,-1.7818 -22.82495,-1.56373 z"
          />
        </clipPath>
      </defs>
      <g id="layer1" transform="translate(226.77038,-65.579386)">
        <g id="g5" transform="translate(-257.55518,-6.5203844)">
          <image
            width="140"
            height="190.14229"
            preserveAspectRatio="true"
            id="image1"
            x="55"
            y="74.238083"
            transform="translate(-2.7401876,-3.4929783)"
            href={casualcutted}
          />
          <path
            id="casual-frame"
            d="m 107.32322,90.090744 c -17.975734,0.08174 -29.688824,8.333476 -47.722917,38.402486 -30.373211,50.64254 -41.029873,44.44064 -9.245234,86.52159 31.784639,42.08095 56.791071,51.2631 105.582191,39.24907 48.79112,-12.01405 59.42975,-23.67205 48.86307,-84.77321 -10.56668,-61.10117 6.87582,-64.53282 -47.75373,-72.464789 -22.19326,-3.222362 -37.42419,-6.991073 -49.72338,-6.935147 z m -2.39352,3.832689 c 5.14213,-0.191042 11.3573,0.296223 19.16248,1.369917 41.6277,5.72637 78.29758,17.04937 75.39225,65.03074 -2.90534,47.98138 11.0459,50.11984 -32.95268,77.40663 C 122.53317,265.01751 98.914123,257.6203 66.235522,223.86586 33.556932,190.11142 26.955479,183.60514 56.50699,142.06518 80.517589,108.31396 82.647186,94.751281 104.9297,93.923433 Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default CasualImageSvg;
